/** @jsx jsx */
import { Flex, TabButton } from "@eworkit/iris";
import React, { FC, useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { RoutedTabs } from "router";
import { jsx } from "theme-ui";

import { IContract } from "@/data/contracts";
import { router } from "@/views/router";

export interface ContractDetailsTabsProps {
  contract: IContract;
}

export const ContractDetailsTabs: FC<ContractDetailsTabsProps> = React.memo(({ contract }) => {
  const { t } = useTranslation("session");

  const details = useCallback(
    (active: boolean, index: number) => (
      <TabButton
        key={index}
        active={active}
        as={Link}
        to={router.get(`contracts.details.details`, { contractId: contract.id }).path}>
        {t("CONTRACTS.DETAILS_TABS.DETAILS")}
      </TabButton>
    ),
    [t, contract],
  );

  const tasks = useCallback(
    (active: boolean, index: number) => (
      <TabButton
        key={index}
        active={active}
        as={Link}
        to={router.get(`contracts.details.tasks`, { contractId: contract.id }).path}>
        {t("CONTRACTS.DETAILS_TABS.TASKS")}
      </TabButton>
    ),
    [t, contract],
  );

  const tabs = useMemo(
    () => ({
      details,
      tasks,
    }),
    [details, tasks],
  );

  return (
    <Flex flexDirection="row" alignItems="flex-end" sx={{ overflowX: "auto" }}>
      <RoutedTabs routeParam="tab" views={tabs} />
    </Flex>
  );
});
